/* v14: mobile conversion details */
(function () {
  var mq = window.matchMedia('(max-width: 760px)');
  /* 1. Header tucks away while scrolling down, comes back on scroll up */
  var hd = document.querySelector('main header') || document.querySelector('header');
  if (hd) {
    var lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY, d = y - lastY, menu = hd.querySelector('details[open]');
        if (!mq.matches || menu || y < 140) hd.classList.remove('ws-hide');
        else if (d > 6) hd.classList.add('ws-hide');
        else if (d < -6) hd.classList.remove('ws-hide');
        lastY = y; ticking = false;
      });
    }, { passive: true });
  }
  /* 2. Sticky bar shows the chosen bundle and saving */
  var bar = document.querySelector('.ws-sticky');
  if (bar) {
    var price = bar.querySelector('[data-ws-total]');
    var info = document.createElement('span'); info.className = 'ws-st-v';
    if (price) price.insertAdjacentElement('afterend', info);
    var row = price && price.parentNode; if (row) row.classList.add('ws-st-col');
    function sync() {
      var on = document.querySelector('.ws-bundle.is-on'); if (!on) { info.textContent = ''; if (row) row.classList.remove('has-v'); return; }
      var t = on.querySelector('.ws-b__t'), s = on.querySelector('.ws-b__save');
      var name = t ? (t.firstChild && t.firstChild.nodeType === 3 ? t.firstChild.textContent : t.textContent).trim() : '';
      info.innerHTML = (name ? '<b>' + name + '</b>' : '') + (s ? '<em>' + s.textContent.trim() + '</em>' : '');
      if (row) row.classList.toggle('has-v', !!name);
      var bi = on.querySelector('.ws-b__img'), si = bar.querySelector('img'); if (bi && si && bi.src) { si.src = bi.src; si.srcset = ''; }
    }
    sync();
    var wrap = document.querySelector('.ws-bundles');
    if (wrap) new MutationObserver(sync).observe(wrap, { attributes: true, subtree: true, attributeFilter: ['class'] });
    /* keep page content clear of the bar */
    new MutationObserver(function () { document.body.classList.toggle('ws-st-on', bar.classList.contains('is-on')); }).observe(bar, { attributes: true, attributeFilter: ['class'] });
  }
  /* 3. Tapping "Add to basket" gives instant feedback */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('#ws-form [type="submit"], [form="ws-form"]');
    if (b && navigator.vibrate) { try { navigator.vibrate(12); } catch (x) {} }
  });
})();
